module.exports = __webpack_public_path__ + "static/media/imagen4_4.cc8a3505.jpg";